"use client";

import React from "react";
import ContactForm from "./contact-form";

type Defaults = {
  first_name: string;
  last_name: string;
  email: string;
  username: string;
};

class ContactFormErrorBoundary extends React.Component<
  { children: React.ReactNode; defaults: Defaults; onRetry: () => void },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="rounded-2xl border border-destructive/30 bg-destructive/10 px-4 py-6 text-center">
          <p className="font-medium text-destructive">Something went wrong</p>
          <p className="mt-1 text-sm text-muted-foreground">
            The form could not be loaded. Please refresh the page or try again later.
          </p>
          <button
            type="button"
            className="mt-3 text-sm underline underline-offset-2"
            onClick={() => {
              this.setState({ hasError: false });
              this.props.onRetry();
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function ContactFormWithBoundary({ defaults }: { defaults: Defaults }) {
  const [formKey, setFormKey] = React.useState(0);
  return (
    <ContactFormErrorBoundary defaults={defaults} onRetry={() => setFormKey((k) => k + 1)}>
      <ContactForm key={formKey} defaults={defaults} />
    </ContactFormErrorBoundary>
  );
}
